import { UsafOrderSource } from '../enums/usaf-order-source.enum'
import { IAdvancedTable, IPaginationFilteredResponse } from '@lla-platform/core/core-data-access'
import { IUsafStockCheckBranch, IUsafStockCheckBranchAvailability } from './usaf-order.interface'

// Grid location (exact match) marking a tire as stocked from USAF. Other vendors'
// stockables use other `stocked*` grids (e.g. `stocked ATD` = ATD) and are never
// ordered from USAF. Mirrors the BE `Const.UsafGridLocation` and is used as an
// Equals filter value against TireInventory.GridLocation.
export const USAF_GRID_LOCATION = 'stocked USAF'

export interface ITireInventorySummaryRequest {
  locationIds?: string[]
}

export interface ILocationTireInventorySummary {
  locationId: string
  locationName: string
  modelsCount: number
  modelsCountFormatted: string
  itemsQty: number
  itemsQtyFormatted: string
  // order*/inFlight*/netToOrder* semantics: GLOSSARY.md glossary ("In-Flight",
  // "Net to Order"); computation: BE TireService.AggregateInventorySummaryAsync.
  orderModelsCount: number
  orderModelsCountFormatted: string
  orderQty: number
  orderQtyFormatted: string
  inFlightModelsCount: number
  inFlightModelsCountFormatted: string
  inFlightQty: number
  inFlightQtyFormatted: string
  netToOrderModelsCount: number
  netToOrderModelsCountFormatted: string
  netToOrderQty: number
  netToOrderQtyFormatted: string
}

export interface ITireInventorySummaryResponse {
  locationTireInventorySummary: ILocationTireInventorySummary[]
  grandTotal: ILocationTireInventorySummary
}

export interface ITireInventoryListItem extends IAdvancedTable {
  id?: string
  locationId?: string
  locationName?: string
  partNumber?: string
  description?: string
  manufacturer?: string
  size?: string
  gridLocation?: string
  inStock?: number
  inStockFormatted?: string
  lowQty?: number
  lowQtyFormatted?: string
  orderQty?: number
  orderQtyFormatted?: string
  lastModified?: string
  usafLineCode?: string
  usafCost?: number | null
  usafBranches?: IUsafStockCheckBranchAvailability[]
  // orderQty is net of in-flight quantities on the order page; neededQty is
  // Protractor's raw reorder qty. The BE always sends all three.
  neededQty: number
  inFlightQty: number
  inFlightOrders: IUsafInFlightOrder[]
}

export interface IUsafInFlightOrder {
  orderId: string
  soNumber?: string
  status: string
  date: string
  deliveryDate?: string
  quantity: number
  source: UsafOrderSource
}

export interface ITireInventoryListTotal extends IAdvancedTable {
  inStock: number
  inStockFormatted: string
  lowQty: number
  lowQtyFormatted: string
  orderQty: number
  orderQtyFormatted: string
  locationName?: string
}

export interface ITireInventoryListResponse extends IPaginationFilteredResponse {
  tires: ITireInventoryListItem[]
  totals: ITireInventoryListTotal
  mainBranch?: string | null
  branches?: IUsafStockCheckBranch[]
}
